import { useCallback, useEffect, useRef } from 'react';
import {
  useFullState,
  useWriteContext,
} from '@/features/remotion-editor/editor/utils/use-context';
import { SafeZonePlatform } from '@/features/remotion-editor/editor/state/types';
import { useIsGsExclusive } from '@/shared/hooks/useTenantUiConfig';

export const useSafeZoneState = () => {
  const state = useFullState();
  const { setState } = useWriteContext();
  const safeZoneGuide = state.safeZoneGuide;

  const isGsrAccountUser = useIsGsExclusive();

  // GS 전용 모드일 때 기본 플랫폼을 gsshop으로 설정 (최초 1회만)
  const hasInitialized = useRef(false);
  useEffect(() => {
    if (
      !hasInitialized.current &&
      isGsrAccountUser &&
      safeZoneGuide.platform === 'youtube'
    ) {
      hasInitialized.current = true;
      setState({
        update: (currentState) => ({
          ...currentState,
          safeZoneGuide: {
            ...currentState.safeZoneGuide,
            platform: 'gsshop',
          },
        }),
        commitToUndoStack: false,
      });
    }
  }, [isGsrAccountUser, safeZoneGuide.platform, setState]);

  const setSafeZoneEnabled = useCallback(
    (enabled: boolean) => {
      setState({
        update: (currentState) => {
          if (currentState.safeZoneGuide.enabled === enabled) {
            return currentState;
          }

          return {
            ...currentState,
            safeZoneGuide: {
              ...currentState.safeZoneGuide,
              enabled,
            },
          };
        },
        commitToUndoStack: false,
      });
    },
    [setState],
  );

  const setSafeZonePlatform = useCallback(
    (platform: SafeZonePlatform) => {
      setState({
        update: (currentState) => {
          if (currentState.safeZoneGuide.platform === platform) {
            return currentState;
          }

          return {
            ...currentState,
            safeZoneGuide: {
              ...currentState.safeZoneGuide,
              platform,
            },
          };
        },
        commitToUndoStack: false,
      });
    },
    [setState],
  );

  return {
    safeZoneGuide,
    isSafeZoneEnabled: safeZoneGuide.enabled,
    setSafeZoneEnabled,
    setSafeZonePlatform,
  };
};
